/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from 'ngx-accordion/Accordion';
const styles_Accordion:any[] = ([] as any[]);
export const RenderType_Accordion:i0.RendererType2 = i0.ɵcrt({encapsulation:2,styles:styles_Accordion,
    data:{}});
export function View_Accordion_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵted(-1,(null as any),['\n'])),(_l()(),i0.ɵeld(1,0,
      (null as any),(null as any),3,'div',[['aria-multiselectable','true'],['class',
          'panel-group'],['role','tablist']],(null as any),(null as any),(null as any),
      (null as any),(null as any))),(_l()(),i0.ɵted(-1,(null as any),['\n    '])),
      i0.ɵncd((null as any),0),(_l()(),i0.ɵted(-1,(null as any),['\n'])),(_l()(),i0.ɵted(-1,
          (null as any),['\n']))],(null as any),(null as any));
}
export function View_Accordion_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),2,'accordion',
      ([] as any[]),(null as any),(null as any),(null as any),View_Accordion_0,RenderType_Accordion)),
      i0.ɵdid(1,1228800,(null as any),1,i1.Accordion,([] as any[]),(null as any),(null as any)),
      i0.ɵqud(603979776,1,{groups:1})],(null as any),(null as any));
}
export const AccordionNgFactory:i0.ComponentFactory<i1.Accordion> = i0.ɵccf('accordion',
    i1.Accordion,View_Accordion_Host_0,{closeOthers:'closeOthers',showArrows:'showArrows',
        expandAll:'expandAll'},{},['*']);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiQzovVXNlcnMvQXN5bHVtL2lkZW50aXR5LXZhZ3JhbnQvc3JjL2FzeWx1bS1pZGVuZXRpdHkvbm9kZV9tb2R1bGVzL25neC1hY2NvcmRpb24vQWNjb3JkaW9uLm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL0M6L1VzZXJzL0FzeWx1bS9pZGVudGl0eS12YWdyYW50L3NyYy9hc3lsdW0taWRlbmV0aXR5L25vZGVfbW9kdWxlcy9uZ3gtYWNjb3JkaW9uL0FjY29yZGlvbi5kLnRzIiwibmc6Ly8vQzovVXNlcnMvQXN5bHVtL2lkZW50aXR5LXZhZ3JhbnQvc3JjL2FzeWx1bS1pZGVuZXRpdHkvbm9kZV9tb2R1bGVzL25neC1hY2NvcmRpb24vQWNjb3JkaW9uLmQudHMuQWNjb3JkaW9uLmh0bWwiLCJuZzovLy9DOi9Vc2Vycy9Bc3lsdW0vaWRlbnRpdHktdmFncmFudC9zcmMvYXN5bHVtLWlkZW5ldGl0eS9ub2RlX21vZHVsZXMvbmd4LWFjY29yZGlvbi9BY2NvcmRpb24uZC50cy5BY2NvcmRpb25fSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCJcbjxkaXYgY2xhc3M9XCJwYW5lbC1ncm91cFwiIHJvbGU9XCJ0YWJsaXN0XCIgYXJpYS1tdWx0aXNlbGVjdGFibGU9XCJ0cnVlXCI+XG4gICAgPG5nLWNvbnRlbnQ+PC9uZy1jb250ZW50PlxuPC9kaXY+XG4iLCI8YWNjb3JkaW9uPjwvYWNjb3JkaW9uPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7O29CQ0FBLDBDQUNBO01BQUE7VUFBQTtNQUFBLDhCQUFvRTthQUNoRSxrQkFBeUIsMENBQ3ZCO1VBQUE7OztvQkNITjtNQUFBO2FBQUE7YUFBQTs7OzsifQ==



// WEBPACK FOOTER //
// C:/Users/Asylum/identity-vagrant/src/asylum-idenetity/src/aot/node_modules/ngx-accordion/Accordion.ngfactory.ts